export const fatSwingOptions = [
  { handle: 'keitech-fat-swing-impact-2-8', text: '2.8"' },
  { handle: 'keitech-fat-swing-impact-3-3', text: '3.3"' },
  { handle: 'keitech-fat-swing-impact', text: '3.8"' },
  { handle: 'keitech-fat-swing-impact-4-3', text: '4.3"' },
  { handle: 'keitech-fat-swing-impact-4-8', text: '4.8"' },
  { handle: 'keitech-fat-swing-impact-5-8', text: '5.8"' },
  { handle: 'keitech-fat-swing-impact-6-8', text: '6.8"' },
];
